var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"popup"},[_c('canvas',{attrs:{"id":"canvas"}}),_c('div',{staticClass:"describe"},[_vm._v(_vm._s(_vm.$t("middleware.qrCode")))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }